export const PAGINATED = 'paginated';
export const ALL_RECORD = 'all';
